export default "__VITE_ASSET__CjU6Ky01__"